"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _VidyardVideoPlayer = _interopRequireDefault(require("ui-addon-video-player/components/VidyardVideoPlayer"));

var _default = function _default(_ref) {
  var handleClose = _ref.handleClose,
      ctaLink = _ref.ctaLink;
  return _react.default.createElement("div", {
    className: "modal display-block"
  }, _react.default.createElement("div", {
    className: "close-container"
  }, _react.default.createElement("a", {
    className: "close",
    onClick: handleClose
  })), _react.default.createElement("section", {
    className: "modal-main"
  }, _react.default.createElement(_VidyardVideoPlayer.default, {
    videoId: "nT2dPi7dvcXfoMxUSCDkif"
  }), _react.default.createElement("div", {
    className: "video-cta-footer"
  }, _react.default.createElement("div", {
    className: "video-cta-banner"
  }, _react.default.createElement("div", {
    className: "title"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "videoHero.title"
  })), _react.default.createElement("div", {
    className: "description"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "videoHero.description"
  }))), _react.default.createElement("div", {
    className: "video-cta-button"
  }, _react.default.createElement("a", {
    className: "button white",
    href: ctaLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "videoHero.button"
  }))))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/VideoModal.js
// module id = 273
// module chunks = 0